
import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from '../../components/ProgressiveImage';
import LogoImage from './LogoImage'; // Alternative clean logo component

function Logo({ src, alt, className, placeholder, style, useCleanLoader = true, ...props }) {
    // Use the dedicated LogoImage component for cleaner loading (recommended)
    if (useCleanLoader) {
        return (
            <div className={className}>
                <LogoImage
                    src={src}
                    alt={alt}
                    style={style}
                    {...props}
                />
            </div>
        );
    }

    // Fallback to ProgressiveImage (legacy support)
    return (
        <div className={className}>
            <ProgressiveImage
                className="Logo"
                src={src}
                alt={alt}
                placeholder="" // Never use placeholder for logos
                showPlaceholder={false}
                style={style}
                {...props}
            />
        </div>
    );
}

Logo.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    useCleanLoader: PropTypes.bool, // Whether to use the dedicated LogoImage component
};

Logo.defaultProps = {
    alt: 'Logo Image',
    className: '',
    placeholder: '',
    style: {},
    useCleanLoader: true, // Default to using the cleaner loader
};

export default Logo;
